import { Component } from '@angular/core';

@Component({
  selector: 'uni-container',
  templateUrl: './uni-container.component.html',
  styleUrls: ['./uni-container.component.scss'],
})
export class UniContainerComponent { }
